import { DomComponentMixin } from '@resn/gozer-core-mixins';
import { Component, componentMixin } from '@resn/gozer-core/component';
import { html } from '@resn/gozer-core';
import DomElementMixin from 'utils/mixins/dom-element';

@componentMixin(DomComponentMixin)
@componentMixin(DomElementMixin)
class TabsCursor extends Component {
    options = {
        prefix: 'tabs',
        template: ({ options }) => html`<div class="${options.prefix}__cursor"></div>`,
    };

    props = {
        align: 'left',
    };

    async onSetup() {}
}
export default TabsCursor;
